module.exports = __webpack_public_path__ + "img/837001769_4.7bd76969.jpg";